import React from 'react';

/**
 * Date template
 */
export const DateTemplate: React.FC<{ dateValue?: string | null }> = ({ dateValue }) => {
  return <span>{dateValue ? new Date(dateValue).toLocaleDateString() : '-'}</span>;
};

export default DateTemplate;
